import { render, staticRenderFns } from "./addOrEditVersion.vue?vue&type=template&id=3f6281fe&scoped=true"
import script from "./addOrEditVersion.vue?vue&type=script&lang=js"
export * from "./addOrEditVersion.vue?vue&type=script&lang=js"
import style0 from "./addOrEditVersion.vue?vue&type=style&index=0&id=3f6281fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6281fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f6281fe')) {
      api.createRecord('3f6281fe', component.options)
    } else {
      api.reload('3f6281fe', component.options)
    }
    module.hot.accept("./addOrEditVersion.vue?vue&type=template&id=3f6281fe&scoped=true", function () {
      api.rerender('3f6281fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/myApp/component/addOrEditVersion.vue"
export default component.exports